import { Box, Button, Text } from '@streamelements/frontend-ui';
import { createFileRoute } from '@tanstack/react-router';
import { ensureOBSPresence } from '../../../utils/ensureOBSPresence';

export const Route = createFileRoute('/auth/tiktok/creator-ineligibility-notice')({
  component: CreatorIneligibilityNotice,
  loader: async () => {
    await ensureOBSPresence();
  },
});

function CreatorIneligibilityNotice() {
  const hasOpenDefaultBrowser = 'openDefaultBrowser' in window.host;

  return (
    <Box
      css={{
        size: '100%',
        maxWidth: 450,
        mx: 'auto',
        display: 'flex',
        flexDirection: 'column',
        padding: '1.5rem',
      }}
    >
      <Text.Heading level={5} weight="bold" css={{ m: 0, mb: '0.5rem' }}>
        Tiktok output creation failed
      </Text.Heading>
      <Text.Body css={{ mb: '1.5rem' }}>
        It seems that you are not eligible to stream on Tiktok. <br />
        Please check your TikTok creator dashboard for more information.
      </Text.Body>

      {!hasOpenDefaultBrowser && (
        <>
          <Text.Body css={{ mb: '1.5rem' }}>
            Press the Copy URL button below to copy the Tiktok application link, then open it in your browser.
          </Text.Body>
        </>
      )}

      <Button density="compact" css={{ mx: 'auto' }} asChild>
        <a
          onClick={(e) => {
            e.preventDefault();

            if (!hasOpenDefaultBrowser) {
              if (navigator.clipboard?.writeText) {
                navigator.clipboard.writeText(e.currentTarget.href);
              } else {
                const textarea = document.createElement('textarea');
                textarea.value = e.currentTarget.href;
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand('copy');
                document.body.removeChild(textarea);
              }
              return;
            }

            window.host.openDefaultBrowser(e.currentTarget.href, () => void 0);
          }}
          href="https://www.tiktok.com/falcon/live_g/live_access_pc_apply/intro/index.html?id=SE7403650104517334022&apply_mode=9"
        >
          {hasOpenDefaultBrowser ? 'View live access' : 'Copy URL'}
        </a>
      </Button>
    </Box>
  );
}
